import React from "react";
import { Reveal, SectionLabel, CTAButton, requestInquiry } from "@/components/site/ui";

export default function Intro() {
  return (
    <section
      id="intro"
      data-testid="intro-section"
      className="py-24 lg:py-36 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-3">
          <Reveal>
            <SectionLabel>Our Practice</SectionLabel>
          </Reveal>
        </div>
        <div className="lg:col-span-9">
          <Reveal delay={0.1}>
            <p className="font-heading text-charcoal text-2xl sm:text-3xl lg:text-[2.6rem] leading-[1.25] tracking-tight">
              Located in the national capital, Ottawa, Ali Sleiman is a member
              in good standing with the{" "}
              <span className="text-crimson">
                College of Immigration and Citizenship Consultants
              </span>{" "}
              (CICC).
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-8 max-w-3xl text-base sm:text-lg text-muted-foreground leading-relaxed">
              With over 30+ years of experience and trusted expertise navigating
              Canada&rsquo;s evolving immigration landscape, we didn&rsquo;t just learn the
              rules yesterday — we have watched the Canadian immigration system
              evolve since the 1990s. We provide professional, reliable, and
              personalized immigration guidance to individuals, families, and
              professionals looking to build their future in Canada.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap gap-4">
              <CTAButton
                testid="intro-contact-btn"
                onClick={() => requestInquiry("contact")}
              >
                Contact Us
              </CTAButton>
              <CTAButton
                testid="intro-book-btn"
                variant="dark"
                onClick={() => requestInquiry("consultation")}
              >
                Book a Consultation
              </CTAButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
